import NameCell from './customCells/NameCell';
import AddToCartCell from './customCells/AddToCartCell';
import PriceAndAvailability from './customCells/PriceAndAvailability';

const getProductName = item => {
  return <NameCell item={item} />;
};

const getPriceAvailability = item => {
  return <PriceAndAvailability item={item} />;
};

const getAddToCartButton = item => {
  return <AddToCartCell item={item} />;
};

const getMobileCell = item => {
  return (
    <>
      <NameCell item={item} />
      <PriceAndAvailability item={item} />
    </>
  );
};
export const getCustomRenderers = () => ({
  name: getProductName,
  addToCart: getAddToCartButton,
  priceAvailability: getPriceAvailability,
  mobileCell: getMobileCell
});
